import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import {
  selectIsAuthenticated,
  selectIsProfileLoaded,
  selectIsLoading,
} from "../../store/slices/authSlice";
import GlobalLoader from "../shared/GlobalLoader";

/**
 * Wraps public pages (landing, login, signup).
 * If the user is already authenticated and their profile is loaded,
 * redirect them straight to /dashboard instead of showing the public page.
 * While auth state is being determined, show a loader to prevent
 * flashing the landing page for already-authenticated users (e.g. PWA on iOS).
 */
function AuthRedirect({ children }) {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const isProfileLoaded = useSelector(selectIsProfileLoaded);
  const isLoading = useSelector(selectIsLoading);

  if (isLoading) {
    return <GlobalLoader message="טוען..." />;
  }

  if (isAuthenticated && isProfileLoaded) {
    return <Navigate to="/dashboard" replace />;
  }

  if (isAuthenticated && !isProfileLoaded) {
    return <GlobalLoader message="טוען פרופיל..." />;
  }

  return children;
}

export default AuthRedirect;
